'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _globals = require('../mixins/globals');

var _globals2 = _interopRequireDefault(_globals);

var _UiAlert = require('../material/UiAlert.vue');

var _UiAlert2 = _interopRequireDefault(_UiAlert);

var _Datepicker = require('../components/Datepicker.vue');

var _Datepicker2 = _interopRequireDefault(_Datepicker);

var _UiIconButton = require('../material/UiIconButton.vue');

var _UiIconButton2 = _interopRequireDefault(_UiIconButton);

var _UiSelect = require('../material/UiSelect.vue');

var _UiSelect2 = _interopRequireDefault(_UiSelect);

var _UiProgressCircular = require('../material/UiProgressCircular.vue');

var _UiProgressCircular2 = _interopRequireDefault(_UiProgressCircular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var selectType = [{ value: '1', text: 'Felicitaciones' }, { value: '2', text: 'Sugerencia' }, { value: '3', text: 'Queja' }];
var format = [{ text: 'XLSX', value: 'xlsx' }, { text: 'XLS', value: 'xls' }, { text: 'CSV', value: 'csv' }];
exports.default = {
  name: 'ListarComentarios',
  mixins: [_globals2.default],
  components: {
    UiAlert: _UiAlert2.default,
    UiIconButton: _UiIconButton2.default,
    UiSelect: _UiSelect2.default,
    UiProgressCircular: _UiProgressCircular2.default,
    DatePicker: _Datepicker2.default
  },
  data: function data() {
    return {
      comments: [],
      locals: [],
      format: format,
      searchedOnce: false,
      tempFormat: null,
      error: {
        status: false,
        messages: ''
      },
      selectType: selectType,
      type_comments: ['Felicitaciones', 'Sugerencia', 'Queja'],
      responseComments: false,
      loadMessages: false,
      disabledBorn: {
        from: new Date()
      },
      born_start: new Date(),
      born_end: new Date(),
      tempLocal: [],
      tempComments: null,
      stringComments: '',
      dateStart: new Date(),
      dateEnd: new Date(),
      countAll: 0,
      flagBornStart: false,
      flagDateStart: false,
      flagBornEnd: false,
      flagDateEnd: false,
      flagLocals: false,
      flagComments: false,
      pagesAll: 1,
      dataComment: {
        page: 1
      },
      localDownloadRequestString: ''
    };
  },


  watch: {
    'error.status': function errorStatus(val, old) {
      var _this = this;

      if (val) {
        setTimeout(function () {
          _this.error.status = false;
        }, 1600);
      }
    },
    tempLocal: function tempLocal(val, old) {
      if (val.length > 0) {
        var self = this;
        this.localDownloadRequestString = '';
        val.forEach(function (value, index, array) {
          self.localDownloadRequestString += '&local_id%5B%5D=' + value.value;
        });
        this.flagLocals = true;
      } else {
        this.flagLocals = false;
      }
    },
    tempComments: function tempComments(val, old) {
      if (val !== null) {
        this.stringComments = val.value;
        this.flagComments = true;
      } else {
        this.stringComments = '';
        this.flagComments = false;
      }
    }
  },
  created: function created() {
    var _d = new Date();
    var _m = _d.getMonth() + 1;
    var _month = _m <= 9 ? '0' + _m : '' + _m;
    this.dateEnd = _d.getFullYear() + '-' + _month + '-' + _d.getDate();
    this.dateStart = _d.getFullYear() + '-' + _month + '-' + _d.getDate();
    // this.loadMessages = false
  },
  ready: function ready() {
    this.fetchLocal();
  },

  methods: {
    showPage: function showPage(_i) {
      if (this.pagesAll < 4) {
        return true;
      } else {
        if (_i + 1 >= this.dataComment.page && _i + 1 <= this.dataComment.page + 4) {
          return true;
        } else {
          return false;
        }
      }
    },
    yymmdd: function yymmdd(_date) {
      var mm = _date.getMonth() + 1;
      var dd = _date.getDate();

      return [_date.getFullYear(), (mm > 9 ? '' : '0') + mm, (dd > 9 ? '' : '0') + dd].join('-');
    },
    onSelectedDateStart: function onSelectedDateStart(_date) {
      this.flagBornStart = true;
      this.dateStart = this.yymmdd(_date);
      this.born_start = _date;
      this.flagDateStart = true;
    },
    onSelectedDateEnd: function onSelectedDateEnd(_date) {
      this.flagBornStart = false;
      this.dateEnd = this.yymmdd(_date);
      this.born_end = _date;
      this.flagDateEnd = true;
    },
    searchComments: function searchComments() {
      var _this2 = this;

      var pages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      this.dataComment = {
        page: pages
      };
      this.loadMessages = false;
      var _url = '/admin/messages';
      if (this.flagLocals) {
        var _tempLocals = [];
        this.tempLocal.forEach(function (val) {
          _tempLocals.push(+val.value);
        });
        this.dataComment['local_id'] = _tempLocals;
      }
      if (this.flagComments) {
        this.dataComment['type'] = +this.tempComments.value;
      }
      if (this.flagDateStart) {
        this.dataComment['after'] = this.dateStart;
      }
      if (this.flagDateEnd) {
        this.dataComment['before'] = this.dateEnd;
      }
      this.$http({
        url: _url,
        method: 'GET',
        params: this.dataComment
      }).then(function (response) {
        var _data = response.data;
        _this2.comments = _data.messages;
        _this2.countAll = _data.total;
        _this2.pagesAll = Math.ceil(_data.total / 20);
        _this2.loadMessages = true;
        _this2.searchedOnce = true;
      }, function (response) {
        if (response.status === 401 || response.status === 403) {
          window.localStorage.removeItem('restaurante');
          window.localStorage.removeItem('local');
          window.localStorage.removeItem('role');
          window.localStorage.removeItem('uid');
          _this2.$router.go({
            name: 'sign'
          });
        }
      });
    },
    fetchMessages: function fetchMessages() {
      var _this3 = this;

      var _url = '/admin/messages';
      this.$http({
        url: _url,
        method: 'GET'
      }).then(function (response) {
        var _data = response.data;
        _this3.comments = _data.messages;
        _this3.countAll = _data.total;
        _this3.pagesAll = Math.ceil(_data.total / 20);

        _this3.$nextTick(function () {
          _this3.responseComments = true;
        });
      }, function (response) {
        if (response.status === 401 || response.status === 403) {
          window.localStorage.removeItem('restaurante');
          window.localStorage.removeItem('local');
          window.localStorage.removeItem('role');
          window.localStorage.removeItem('uid');
          _this3.$router.go({
            name: 'sign'
          });
        }
      });
    },
    fetchLocal: function fetchLocal() {
      var _this4 = this;

      var _url = '/admin/local';
      this.$http({
        url: _url,
        method: 'GET'
      }).then(function (response) {
        var _data = response.data;
        _data.forEach(function (val) {
          _this4.locals.push({
            text: val.name,
            value: val.id + ''
          });
        });
        _this4.loadMessages = true;
        // let _data = response.data
        _this4.$nextTick(function () {
          _this4.fetchMessages();
        });
      }, function (response) {
        if (response.status === 401 || response.status === 403) {
          window.localStorage.removeItem('restaurante');
          window.localStorage.removeItem('local');
          window.localStorage.removeItem('role');
          window.localStorage.removeItem('uid');
          _this4.$router.go({
            name: 'sign'
          });
        }
      });
    }
  }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"bgTransition\">\n  <template v-if=\"!responseComments\">\n    <div class=\"preload-app\">\n      <ui-progress-linear :show=\"true\" color=\"black\"></ui-progress-linear>\n    </div>\n  </template>\n  <template v-else=\"\">\n    <div class=\"header-section h_contact\">\n      <h2 v-if=\"titleShow\" transition=\"slideLeft\">Lista de Comentarios</h2>\n    </div>\n    <section class=\"section-users\">\n      <div class=\"width-users min-height clearfix table-responsive\">\n        <h5 class=\"subtitle_assign\">Busqueda</h5>\n        <div class=\"row\">\n          <div class=\"col-xs-6 col-md-3\">\n            <date-picker label=\"Fecha de Inicio\" :value=\"born_start\" format=\"yyyy/MM/dd\" placeholder=\"DD/MM/YYYY\" input-class=\"ui-textbox-input\" language=\"es\" :disabled=\"disabledBorn\" @selected=\"onSelectedDateStart\"></date-picker>\n          </div>\n          <div class=\"col-xs-6 col-md-3\">\n            <date-picker label=\"Fecha de Fin\" :value=\"born_end\" format=\"yyyy/MM/dd\" placeholder=\"DD/MM/YYYY\" input-class=\"ui-textbox-input\" language=\"es\" :disabled=\"disabledBorn\" @selected=\"onSelectedDateEnd\"></date-picker>\n          </div>\n          <div class=\"col-xs-12 col-md-3\">\n            <ui-select name=\"local\" label=\"Local\" :options=\"locals\" multiple=\"\" placeholder=\"Seleccione un local\" :value.sync=\"tempLocal\"></ui-select>\n          </div>\n          <div class=\"col-xs-12 col-md-3\">\n            <ui-select name=\"type_comment\" label=\"Tipo de Comentario\" :options=\"selectType\" placeholder=\"Seleccione un tipo\" :value.sync=\"tempComments\"></ui-select>\n          </div>\n        </div>\n        <div class=\"row\">\n          <div class=\"col-xs-12 button-search\">\n            <ui-button color=\"lanacional-primario\" raised=\"\" @click=\"searchComments()\" text=\"Buscar\"></ui-button>\n          </div>\n        </div>\n        <template v-if=\"!loadMessages\">\n          <div class=\"load_messages\">\n            <ui-progress-circular :size=\"50\" :show=\"true\" color=\"black\"></ui-progress-circular>\n          </div>\n        </template>\n        <template v-else=\"\">\n          <template v-if=\"comments.length > 0\">\n            <div v-if=\"searchedOnce\" class=\"text-left\" style=\"color: white\">\n              <ui-select name=\"level\" label=\"Formato\" :options=\"format\" placeholder=\"Seleccione una opción\" :value.sync=\"tempFormat\" default=\"xlsx\"></ui-select>\n              <a :href=\"'/admin/stats/export_comments?before='+dateEnd+'&amp;after='+dateStart+localDownloadRequestString+'&amp;format='+tempFormat.value+'&amp;type='+stringComments\" download=\"\">DESCARGAR LISTA DE COMENTARIOS</a>\n            </div>\n            <hr>\n            <table class=\"table table-striped table-bordered\" style=\"margin: 0\">\n              <thead>\n                <tr>\n                  <th>Nombres</th>\n                  <th>Apellidos</th>\n                  <th>Correo</th>\n                  <th>Tipo de comentario</th>\n                  <th>Mensaje</th>\n                  <th>Local</th>\n                  <th>Fecha</th>\n                </tr>\n              </thead>\n              <tbody>\n                <template v-for=\"item of comments | orderBy 'created_at' -1\">\n                  <tr>\n                    <td>\n                      <template v-if=\"isDataNull(item.firstname)\">Datos no registrados</template>\n                      <template v-else=\"\">{{item.firstname}}</template>\n                    </td>\n                    <td>\n                      <template v-if=\"isDataNull(item.lastname)\">Datos no registrados</template>\n                      <template v-else=\"\">{{item.lastname}}</template>\n                    </td>\n                    <td>\n                      <template v-if=\"isDataNull(item.email)\">Datos no registrados</template>\n                      <template v-else=\"\">{{item.email}}</template>\n                    </td>\n                    <td>{{type_comments[item.type-1]}}</td>\n                    <td>{{item.body}}</td>\n                    <td>{{item.local_name}}</td>\n                    <td>{{item.created_at}}</td>\n                  </tr>\n                </template>\n              </tbody>\n            </table>\n            <div class=\"clearfix\">\n              <ul class=\"pagination\">\n                <li v-if=\"dataComment.page > 1\">\n                  <a href=\"#\" aria-label=\"Previous\" @click.prevent=\"searchComments(dataComment.page-1)\">\n                    <span aria-hidden=\"true\">«</span>\n                  </a>\n                </li>\n                <template v-if=\"pagesAll > 1\">\n                  <template v-for=\"i in pagesAll\">\n                    <li v-if=\"showPage(i)\" :class=\"{ 'active': dataComment.page == (i+1)}\">\n                      <a href=\"#\" @click.prevent=\"searchComments(i+1)\">{{i+1}}</a>\n                    </li>\n                  </template>\n                </template>\n                <li v-if=\"dataComment.page < pagesAll\">\n                  <a href=\"#\" aria-label=\"Next\" @click.prevent=\"searchComments(dataComment.page+1)\">\n                    <span aria-hidden=\"true\">»</span>\n                  </a>\n                </li>\n              </ul>\n            </div>\n          </template>\n          <template v-else=\"\">\n            <ui-alert :dismissible=\"false\">No hay comentarios registrados.</ui-alert>\n          </template>\n        </template>\n      </div>\n    </section>\n  </template>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-b0a5cd5e", module.exports)
  } else {
    hotAPI.update("_v-b0a5cd5e", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}